export default [
  {
    path: '/customer_prices/:id',
    name: 'customer_prices',
    component: () => import('@/views/pages/customers/CustomerPrices.vue'),
    meta: {
      pageTitle: 'Customer Prices',
      breadcrumb: {
        label: 'Customer Prices',
        parent: 'customers_list'
      }
    }
  },
  {
    path: '/customer_prices/:id/create',
    name: 'create_customer_prices',
    component: () => import('@/views/pages/customers/CreateCustomerPrices.vue'),
    meta: {
      pageTitle: 'Create Customer Prices',
      breadcrumb: {
        label: 'Create Customer Prices',
        parent: 'customer_prices'
      }
    }
  },
  {
    path: '/customer_prices/:id/:customer_price_id/edit',
    name: 'edit_customer_prices',
    component: () => import('@/views/pages/customers/EditCustomerPrices.vue'),
    meta: {
      pageTitle: 'Edit Customer Prices',
      breadcrumb: {
        label: 'Edit Customer Prices',
        parent: 'customer_prices'
      }
    }
  }
];
